import { render, staticRenderFns } from "./SelectableResourceHeader.vue?vue&type=template&id=01a9e834&"
import script from "./SelectableResourceHeader.vue?vue&type=script&lang=ts&"
export * from "./SelectableResourceHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports